module.exports = __webpack_public_path__ + "static/media/eu-logo.96271709.svg";